import { render, staticRenderFns } from "./billLadingManage.vue?vue&type=template&id=256bbbcc&scoped=true"
import script from "./billLadingManage.vue?vue&type=script&lang=js"
export * from "./billLadingManage.vue?vue&type=script&lang=js"
import style0 from "./billLadingManage.vue?vue&type=style&index=0&id=256bbbcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256bbbcc",
  null
  
)

export default component.exports